import { render, staticRenderFns } from "./Archive-Debates.vue?vue&type=template&id=6ccb5e2a&scoped=true&"
import script from "./Archive-Debates.vue?vue&type=script&lang=js&"
export * from "./Archive-Debates.vue?vue&type=script&lang=js&"
import style0 from "./Archive-Debates.vue?vue&type=style&index=0&id=6ccb5e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccb5e2a",
  null
  
)

export default component.exports